import type Mithril from 'mithril';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import Post from 'flarum/common/models/Post';
import icon from 'flarum/common/helpers/icon';
import CommentPost from 'flarum/forum/components/CommentPost';
import app from 'flarum/forum/app';
import includePostNumber from '../utils/includePostNumber';

export interface ReplyListAttrs extends ComponentAttrs {
  post: Post;
}

export default class ReplyList extends Component<ReplyListAttrs> {
  limit = 5;

  oninit(vnode: Mithril.Vnode<ReplyListAttrs, this>) {
    super.oninit(vnode);
    this.loadNumber(app.current.get('stream').number);
  }

  onbeforeupdate(vnode: Mithril.VnodeDOM<ReplyListAttrs, this>) {
    super.onbeforeupdate(vnode);
    this.loadNumber(app.current.get('stream').number);
  }

  view(vnode: Mithril.Vnode<ReplyListAttrs, this>): Mithril.Children {
    const { post } = this.attrs;

    if (!post.mentionedBy()?.length) {
      return null;
    }

    const replyData = post.mentionedBy().slice(0, this.limit);
    const replyCount = post.mentionedByCount();

    return (
      <div className="Post-mentionedBy-container">
        {replyData.map((reply: Post) => (
          <div
            className="PostStream-item"
            key={`post${reply.id()}`}
            data-time={reply.createdAt().toISOString()}
            data-number={reply.number()}
            data-id={reply.id()}
            data-type={reply.contentType()}
          >
            <CommentPost post={reply} />
          </div>
        ))}
        {/*<LoadingIndicator />*/}
        <div className="Post-mentionedBy-actions" style={replyData.length && 'margin-top: 10px'}>
          {replyData.length < replyCount && (
            <span className="Post-mentionedBy-more" onclick={() => this.showMore()}>
              {icon('fas fa-reply-all')}
              展开 {replyCount - replyData.length} 条回复
            </span>
          )}
          {this.limit > 0 && (
            <span className="Post-mentionedBy-hide" onclick={() => this.hideMore()}>
              {icon('fas fa-chevron-up')}
              收起
            </span>
          )}
        </div>
      </div>
    );
  }

  loadNumber(number?: number) {
    if (!number) return;
    const replies = this.attrs.post.mentionedBy();
    if (!replies?.length) return;
    const index = replies.findIndex((post) => includePostNumber(post, number));
    if (index < 0) return;
    this.limit = Math.max(this.limit, index + 1);
  }

  showMore(size = 5) {
    this.limit += size;
    m.redraw();
  }

  hideMore() {
    this.limit = 0;

    const $window = $(window);
    const $element = this.$();
    if ($window.scrollTop() > $element.offset().top) {
      $window.scrollTop($window.scrollTop() - ($window.scrollTop() - $element.offset().top));
    }

    // m.redraw();
  }
}
